class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    if (facetForm) {
      facetForm.addEventListener('input', (event) => {
        // prevent form submission if the user is typing in a range dimension input
        if (!event.target.classList.contains('facets-range-dimension-input')) {
            this.debouncedOnSubmit(event);
        };
      });
    };

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.dispatchEvent(new CustomEvent('as:grid-render', {
      detail: {
         message: 'Grid has been rendered'
      }
     }))

    if (!new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer')) {
      alert("Oops! Your filter criteria are too extensive. \nPlease refine your selection for better results.");
      const baseUrl = window.location.origin + window.location.pathname;
      window.location.href = baseUrl;
      return;
    };

    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    // make entire card clickable after re-rendering
    const productCards = document.querySelectorAll(".product-card-wrapper");

    productCards.forEach((card) => {
      const colorSwatch = card.querySelector('.color-swatch')
      const variantBadge = colorSwatch.dataset.variantBadges;
      const variantBadgePosition = colorSwatch.dataset.badgePosition;
      FacetFiltersForm.plpDisplayVariantBadges(variantBadge, variantBadgePosition, card);
    });
  }

  static plpDisplayVariantBadges = (variantBadge, variantBadgePosition, productCard) => {
    // Remove existing js added badges
    const existingJsBadges = productCard.querySelectorAll('.js-card__badge');
    if (existingJsBadges) {
      existingJsBadges.forEach((badge) => {
        badge.remove();
      });
    };
    //Add new badges
    if (!variantBadge) return;
    const variantBadgeArray = variantBadge.split(',');
    const badgeContainer = productCard.querySelector('.card__badge--container');
    const badgeAcount = badgeContainer.querySelectorAll('.card__badge--container .card__badge').length;
    if (badgeAcount >=  2) return;
    for (let i = badgeAcount; i < 2; i++) {
      if (variantBadgeArray[i]) {
        const badge = `
          <div class="card__badge js-card__badge ${variantBadgePosition}">
            <span class="badge badge--bottom-left color-background-2">${variantBadgeArray[i]}</span>
          </div>`;
        badgeContainer.insertAdjacentHTML('beforeend', badge);
      };
    };
  };

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter, #FacetFiltersAvailabilityForm .js-filter, #FacetFiltersAvailabilityFormMobile .js-filter, #FacetFiltersStockForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

    setupPriceRangeFilter();
    setupDimensionRangeFilters();
    resetSessionStorageDimensionValues();
    applySessionStorageDimensionValues();
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.classList.contains('mobile-facets__checkbox')) {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = (event.target.closest('form').id === 'FacetFiltersFormMobile-Separate') || (event.target.closest('form').id === 'FacetFiltersFormMobile');

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm' || form.id === 'FacetFiltersAvailabilityForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile-Separate' || form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

setupPriceRangeFilter = () => {
  const sliderLarge = document.getElementById('slider--price-range-large');

  if (sliderLarge) {
    const sliderMin = parseFloat(sliderLarge.dataset.min);
    const sliderMinCurrent = parseFloat(sliderLarge.dataset.minCurrent);
    const sliderMax = parseFloat(sliderLarge.dataset.max);
    const sliderMaxCurrent = parseFloat(sliderLarge.dataset.maxCurrent);

    noUiSlider.create(sliderLarge, {
      start: [sliderMin, sliderMax],
      connect: true,
      range: {
        'min': sliderMin,
        'max': sliderMax
      },
      step: 100
    });

    sliderLarge.noUiSlider.set([sliderMinCurrent, sliderMaxCurrent]);

    const rangeSliderValueElement = document.querySelector('.slider-range-value');

    if (rangeSliderValueElement) {
      sliderLarge.noUiSlider.on('change', (values, handle) => {
          const rangeLowValue = rangeSliderValueElement.querySelector('.low-value');
          rangeLowValue.innerHTML = `$ ${values[0]}`;
          const rangeHighValue = rangeSliderValueElement.querySelector('.high-value');
          rangeHighValue.innerHTML = `$ ${values[1]}`;
          // rangeSliderValueElement.innerHTML = values.join(' - ');

          // update the hidden fields to get the filter to work
          // Filter-Price-GTE, Filter-Price-LTE
          const facetsForm = document.getElementById('FacetFiltersForm');
          const eventPriceChange = new Event('input');
          const priceGTE = document.getElementById('Filter-Price-GTE');
          const priceLTE = document.getElementById('Filter-Price-LTE');

          if (handle === 0) {
            priceGTE.value = values[handle];
            facetsForm.dispatchEvent(eventPriceChange);
          }

          if (handle === 1) {
            priceLTE.value = values[handle];
            facetsForm.dispatchEvent(eventPriceChange);
          }
      });
    }
  }
}

domReady(setupPriceRangeFilter);

const setupDimensionRangeFilters = () => {
	const facetRangeFilters = document.querySelectorAll('.facets-range-dimension-container');
	facetRangeFilters.forEach(rangeFilter => initRangeFilter(rangeFilter));
	resetSessionStorageDimensionValues();
	applySessionStorageDimensionValues();
};

domReady(setupDimensionRangeFilters);

const initRangeFilter = (rangeFilter) => {
	const rangeInputs = rangeFilter.querySelectorAll('.facets-range-dimension-input')
	rangeInputs.forEach(input => {
		const isMinInput = input.classList.contains('facets-range-dimension-input-min')
		const dimensionType = input.dataset.dimensionType
		const minLimit = parseFloat(input.min)
		const maxLimit = parseFloat(input.max)

		input.addEventListener('change', () => {
			if (parseFloat(input.value) < minLimit) {
        input.value = minLimit;
      };
      if (parseFloat(input.value) > maxLimit) {
        input.value = maxLimit;
      };

			// find the other input in the rangeFilter parent element
			const compareInput = isMinInput ? 
				rangeFilter.querySelector('.facets-range-dimension-input-max') : 
				rangeFilter.querySelector('.facets-range-dimension-input-min');
			if (!compareInput || !compareInput.value) return;

			const minValue = parseFloat(input.value) > parseFloat(compareInput.value) ?
				parseFloat(compareInput.value) : 
				parseFloat(input.value);
      const maxValue = parseFloat(input.value) < parseFloat(compareInput.value) ? 
				parseFloat(compareInput.value) : 
				parseFloat(input.value);
      
			applyRangeFilterValues(minValue, maxValue, dimensionType);
		})
	})
};

const applyRangeFilterValues = (minValue, maxValue, dimensionType) => {
	const dimensionLists = document.querySelectorAll('.facets-dimension-list');
  const dimensionListsArray = Array.from(dimensionLists);
	const macthedDimensionList = dimensionListsArray.find(list => list.dataset.dimensionType === dimensionType);

	if (!macthedDimensionList) return;
	
	updateDimensionCheckboxes(macthedDimensionList, minValue, maxValue);

	const dimensionInputType = dimensionType.replace('overall', '').replace('(in inches)', '').trim();
  sessionStorage.setItem(`range-dimention-min-${dimensionInputType}`, minValue);
  sessionStorage.setItem(`range-dimention-max-${dimensionInputType}`, maxValue);
};

const updateDimensionCheckboxes = (dimensionList, minInputValueNumber, maxInputValueNumber) => {
	const macthedDimensionCheckboxes = dimensionList.querySelectorAll('input[type="checkbox"]');

	let checkedDimensionCheckboxesCount = 0;
  macthedDimensionCheckboxes.forEach((checkbox) => {
		checkbox.removeAttribute('checked');
		
		if (checkbox.disabled) return;
		
    const checkboxValue = parseFloat(checkbox.value);
    if (checkboxValue >= minInputValueNumber && checkboxValue <= maxInputValueNumber) {
        checkbox.click();
        checkedDimensionCheckboxesCount++; 
    };
  });

  if (checkedDimensionCheckboxesCount === 0) {
    noneOfBoxCheckedNofitication(dimensionList);
  };
};

function resetSessionStorageDimensionValues () {
  const rangeDimensionRemoveDepth = document.querySelector('.facet-remove__range-depth'); 
  const rangeDimensionRemoveWidth = document.querySelector('.facet-remove__range-width');
  const rangeDimensionRemoveHeight = document.querySelector('.facet-remove__range-height');
  if (!rangeDimensionRemoveDepth) {
    sessionStorage.removeItem('range-dimention-min-depth');
    sessionStorage.removeItem('range-dimention-max-depth');
  };
  if (!rangeDimensionRemoveWidth) {
    sessionStorage.removeItem('range-dimention-min-width');
    sessionStorage.removeItem('range-dimention-max-width');
  };
  if (!rangeDimensionRemoveHeight) {
    sessionStorage.removeItem('range-dimention-min-height');
    sessionStorage.removeItem('range-dimention-max-height');
  };
};

const applySessionStorageDimensionValues = () => {
	const dimensionTypes = ['depth', 'width', 'height']
	dimensionTypes.forEach(type => applySessionValuesToDimensionElements(type))
};

const applySessionValuesToDimensionElements = (type) => {
  const rangeDimensionMin = sessionStorage.getItem(`range-dimention-min-${type}`);
  const rangeDimensionMax = sessionStorage.getItem(`range-dimention-max-${type}`);
  const rangeDimensionRemove = document.querySelectorAll(`.facet-remove__range-${type}`); 
  
  if (rangeDimensionRemove && rangeDimensionMin && rangeDimensionMax) {
    rangeDimensionRemove.forEach((removeButton) => {
      removeButton.querySelector(`.facet-remove__values-${type}`).innerHTML = `${parseFloat(rangeDimensionMin).toFixed(2)} - ${parseFloat(rangeDimensionMax).toFixed(2)}`;
    });
  };
  
  const rangeDimensionMinInput = document.querySelectorAll(`.facets-range-dimension-input-min-${type}`);
  if (rangeDimensionMinInput && rangeDimensionMin) {
    rangeDimensionMinInput.forEach((minInput) => {
      minInput.value = parseFloat(rangeDimensionMin).toFixed(2);
    });
  };

  const rangeDimensionMaxInput = document.querySelectorAll(`.facets-range-dimension-input-max-${type}`);
  if (rangeDimensionMaxInput && rangeDimensionMax) {
    rangeDimensionMaxInput.forEach((maxInput) => {
      maxInput.value = parseFloat(rangeDimensionMax).toFixed(2);
    });
  };
};


const noneOfBoxCheckedNofitication = (macthedDimensionList) =>  {
  const macthedDimensionListContainer = macthedDimensionList.parentElement;
  if (!macthedDimensionListContainer) return;

	const macthedDimensionInputContainer = macthedDimensionListContainer.parentElement;
	if (!macthedDimensionInputContainer) return;

	const noneOfBoxCheckedNofitication = document.createElement('p');
	noneOfBoxCheckedNofitication.classList.add('none-of-box-checked-notification');
	noneOfBoxCheckedNofitication.innerHTML = `No matching dimensions due to the applied filters.<br>Please try another range.`;

	macthedDimensionInputContainer.insertBefore(
		noneOfBoxCheckedNofitication,
		macthedDimensionListContainer.nextSibling
	);

	setTimeout(() => {
		noneOfBoxCheckedNofitication.style.opacity = 0;
	}, 2500);

	setTimeout(() => {
		noneOfBoxCheckedNofitication.remove();
	}, 3000);
};